import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'

import {ButtonLink} from '@vio/atlas/ButtonLink'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Icon} from '@vio/atlas/Icon'
import {Tooltip, TooltipPlacement} from '@vio/atlas/Tooltip'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {CashbackMessageProps} from '../../../types/cashback'
import {CashbackKarmaText} from './CashbackKarmaText'

export interface CashbackKarmaWithInfoProps extends CashbackMessageProps {
  onInfoClick?: (value: number) => void
}

const stopOfferClick = (e: React.MouseEvent) => {
  e.preventDefault()
  e.stopPropagation()
}

export const CashbackKarmaWithInfo = ({
  value,
  variant,
  messages,
  onInfoClick
}: CashbackKarmaWithInfoProps) => {
  const {formatMessage, formatNumber} = useIntl()
  const {isDesktop} = useDeviceLayout()

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      stopOfferClick(e)
      onInfoClick?.(value)
    },
    [onInfoClick, value]
  )

  const infoTitle = formatMessage(messages.cashbackInfoTitle!, {
    value: formatNumber(value / 100, {style: 'percent'})
  })
  const infoContentMessage = messages.cashbackInfoContent!

  if (isDesktop) {
    return (
      <Tooltip
        placement={TooltipPlacement.BottomEnd}
        title={infoTitle}
        content={<FormattedMessageWrapper {...infoContentMessage} />}
      >
        <ButtonLink
          tag="span"
          variant="secondary"
          isDotted
          size="sm"
          isBold
          isCompact
          iconEnd={
            <Icon name="Information" colorPath="content.brand.primary" />
          }
          onClick={stopOfferClick}
        >
          <CashbackKarmaText
            value={value}
            variant={variant}
            messages={messages}
          />
        </ButtonLink>
      </Tooltip>
    )
  }

  return (
    <ButtonLink
      tag="span"
      variant="secondary"
      isDotted
      size="sm"
      isBold
      isCompact
      iconEnd={<Icon name="Information" colorPath="content.brand.primary" />}
      onClick={handleClick}
    >
      <CashbackKarmaText value={value} variant={variant} messages={messages} />
    </ButtonLink>
  )
}
